import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.push.js";
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/images/pc/icons/icon-thread.png';
import _imports_1 from '@/assets/images/pc/icons/icon-draft.png';
import _imports_2 from '@/assets/images/pc/icons/icon-reply.png';
import _imports_3 from '@/assets/images/pc/icons/icon-message.png';
import _imports_4 from '@/assets/images/pc/icons/icon-bill.png';
import _imports_5 from '@/assets/images/pc/icons/icon-logout.png';
const _hoisted_1 = {
  class: "earring-box"
};
const _hoisted_2 = {
  key: 0,
  class: "earrings left"
};
const _hoisted_3 = {
  key: 1,
  class: "earrings right"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "today-thread"
}, "今日热议", -1);
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = {
  key: 0,
  class: "today-thread__no-item"
};
const _hoisted_8 = {
  key: 1,
  class: "search-history d-flex"
};
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", {
  class: "ico-clear"
}, null, -1);
const _hoisted_10 = {
  key: 2,
  class: "search-history__items d-flex flex-wrap"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", {
  class: "ico-sign-in"
}, null, -1);
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", {
  class: "ico-share"
}, null, -1);
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  key: 0,
  class: "new-prompt"
};
const _hoisted_16 = {
  class: "nickname"
};
const _hoisted_17 = {
  class: "credits"
};
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "福米：", -1);
const _hoisted_19 = {
  class: "credits-amount"
};
const _hoisted_20 = {
  class: "menu"
};
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: 17,
  height: 18,
  alt: ""
}, null, -1);
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, "我的主页", -1);
const _hoisted_23 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  width: 17,
  height: 17,
  alt: ""
}, null, -1);
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, "我的草稿箱", -1);
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  width: 18,
  height: 16,
  alt: ""
}, null, -1);
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, "我的回复", -1);
const _hoisted_27 = ["height"];
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", null, "系统消息", -1);
const _hoisted_29 = {
  key: 0,
  class: "new-prompt"
};
const _hoisted_30 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  width: 17,
  height: 19,
  alt: ""
}, null, -1);
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", null, "我的帐单", -1);
const _hoisted_32 = ["height"];
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", null, "退出", -1);
import { inject } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from 'vue-router';
import { useActions, useState } from '@/utils/map-state';
import { promoteUrl } from "@/utils/url";
import { ref, computed, watch, onMounted, reactive } from 'vue';
import { homeCategoryTable } from "@/composable/commonFunction/categoryTable";
import duFloatMenu from "@/components/pc/home/duFloatMenu.vue";
export default {
  __name: 'headerV2PC',
  props: {
    data: {
      type: Array,
      default: () => [{
        txt: '',
        val: ''
      }]
    },
    selected: {
      type: String,
      default: ''
    }
  },
  setup(__props) {
    const props = __props;
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const userState = useState('user', ['userInfo', 'isLogin']);
    const {
      userInfo,
      isLogin
    } = userState;
    const commonActions = useActions('common', ['showLoginBox', 'showSignPopup']);
    const {
      logout
    } = useActions('user', ['logout']);
    const versionControl = computed(() => store.state.versionControl);
    const selectedItem = computed(() => props.selected);
    const inNewYear2023 = computed(() => store.state.common.inNewYear2023); // 2023 新春裝飾
    const searchKeyword = ref('');
    const searchTxt = ref(null);
    const state = reactive({
      todayHotThread: [],
      searchHistory: [],
      mouseInMenu: false,
      isShowSearchMenu: false,
      isShowHistory: false
    });
    const duFloatMenuRef = ref();
    const {
      switchHeaderTab
    } = inject('activeHeaderTab');
    const showDufloatMenu = event => {
      if (event.target.classList.contains('active')) {
        return;
      }
      clearTimeout(duFloatMenuRef.value.duFloatMenuTimeoutId);
      document.querySelector('.du-float-menu') ? document.querySelector('.du-float-menu').classList.remove('hidden') : '';
    };
    const forceHiddenDuFloatMenu = event => {
      if (event.target.dataset.du || event.target.closest('.du-float-menu')) {
        return;
      }
      duFloatMenuRef.value.forceHiddenDuFloatMenu();
    };

    // 由 route 參數決定 Header activeClass
    const activeClass = computed(() => {
      if (route.name === 'forum') {
        return 'recommend';
      } else if (route.name === 'home') {
        const temp = [...homeCategoryTable].filter(item => item.val === +route.query.forum).length ? [...homeCategoryTable].filter(item => item.val === +route.query.forum) : [...homeCategoryTable].filter(item => item.home);
        return temp[0]['key'];
      }
      return '';
    });

    // header跳轉路由及登入驗證
    const headerRouter = header => {
      document.querySelector('.du-float-menu') ? document.querySelector('.du-float-menu').classList.add('hidden') : '';
      const params = [...homeCategoryTable].filter(item => item.key === header);
      if (params[0]['requireAuth'] && !store.state.user.isLogin) {
        const url = document.URL;
        window.location.replace(promoteUrl() + '/member_vue.php?platform=2&method=login&back=' + encodeURIComponent(url));
        return;
      }
      switchHeaderTab(header);
      router.push({
        name: 'home',
        query: {
          forum: params[0]['val']
        }
      });
    };
    const gotoShare = () => {
      window.location = promoteUrl() + '/forum.php?mod=post&action=newthread&fid=' + (selectedLayer1.value === '3' ? '62' : '56') + '&newpost=1&referer=' + encodeURIComponent('/n/#' + route.fullPath);
    };

    // 導航狀態
    // ---------------------------------------------------
    const selectedLayer1 = computed({
      get() {
        return store.getters['forum/selectedForumLayer1'];
      },
      set() {}
    });
    onMounted(() => {
      searchKeyword.value = route.params.keyword;
      getTodayThread();
    });
    watch(() => route.params.keyword, () => {
      searchKeyword.value = route.params.keyword;
    });
    const getTodayThread = () => {
      store.dispatch('search/searchHotThread', {
        showError: false
      }).then(result => {
        var _result$list;
        if (((_result$list = result.list) === null || _result$list === void 0 ? void 0 : _result$list.length) > 0) {
          state.todayHotThread = result.list;
        }
      });
    };
    const gotoSearch = keyword => {
      if (!keyword) {
        return;
      }
      router.push({
        path: '/search/' + keyword
      });
      displaySearchMenu(false, true);
    };
    const gotoThread = () => {
      window.location = promoteUrl() + '/home.php?mod=space&do=thread';
    };
    const gotoThreadDetailPage = tid => {
      window.location = promoteUrl() + `/forum.php?mod=redirect&goto=findpost&ptid=${tid}`;
    };
    const showLoginBox = method => {
      // 直接跳轉
      window.location = promoteUrl() + '/member_vue.php?platform=1&method=' + (method === 'reg' ? method : 'login') + '&back=' + encodeURIComponent(document.URL);
    };
    const updateMouseInMenu = isIn => {
      state.mouseInMenu = isIn;
    };

    // 切換顯示/隱藏搜索菜單
    const displaySearchMenu = (display, clickTarget = false) => {
      if (display) updateHistory();
      if (!state.mouseInMenu) {
        state.isShowSearchMenu = display;
      } else {
        if (!clickTarget) {
          var _searchTxt$value;
          (_searchTxt$value = searchTxt.value) === null || _searchTxt$value === void 0 ? void 0 : _searchTxt$value.focus();
        }
      }
    };
    const updateHistory = () => {
      state.searchHistory = Object.values(JSON.parse(decodeURIComponent(getCookie('sh-v3') || '{}')));
      if (state.searchHistory.length > 0) state.isShowHistory = true;
    };

    // 清空搜索紀錄
    const clearHistory = () => {
      eraseCookie('sh-v3');
      state.isShowHistory = false;
    };
    const showSignPopup = show => {
      commonActions.showSignPopup({
        show
      });
    };
    return (_ctx, _cache) => {
      const _component_image_cdn = _resolveComponent("image-cdn");
      const _component_van_col = _resolveComponent("van-col");
      const _component_van_row = _resolveComponent("van-row");
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("header", {
        id: "header-pc",
        class: _normalizeClass({
          inNewYear2023: _unref(inNewYear2023)
        }),
        onMouseover: forceHiddenDuFloatMenu
      }, [_createElementVNode("div", _hoisted_1, [_unref(inNewYear2023) ? (_openBlock(), _createElementBlock("div", _hoisted_2)) : _createCommentVNode("", true), _unref(inNewYear2023) ? (_openBlock(), _createElementBlock("div", _hoisted_3)) : _createCommentVNode("", true)]), _createVNode(_component_van_row, {
        class: "header-content",
        justify: "space-between",
        align: "center"
      }, {
        default: _withCtx(() => [_createVNode(_component_image_cdn, {
          src: require('@/assets/images/pc/du-logo-slogan.png'),
          width: "215px",
          height: "41px",
          class: "du-logo"
        }, null, 8, ["src"]), _createVNode(_component_van_row, {
          class: "tabs",
          justify: "space-around",
          align: "center"
        }, {
          default: _withCtx(() => [_createVNode(_component_van_col, {
            class: _normalizeClass(["tab", {
              'active': _unref(activeClass) === 'recommend'
            }]),
            "data-du": "1",
            onMouseover: showDufloatMenu,
            onClick: _cache[0] || (_cache[0] = _withModifiers($event => headerRouter('recommend'), ["prevent"]))
          }, {
            default: _withCtx(() => [_createTextVNode("DU圈")]),
            _: 1
          }, 8, ["class"]), _createVNode(_component_van_col, {
            class: _normalizeClass(["tab", {
              'active': _unref(activeClass) === 'ranking'
            }]),
            onClick: _cache[1] || (_cache[1] = _withModifiers($event => headerRouter('ranking'), ["prevent"]))
          }, {
            default: _withCtx(() => [_createTextVNode("热榜")]),
            _: 1
          }, 8, ["class"]), _createVNode(_component_van_col, {
            class: _normalizeClass(["tab", {
              'active': _unref(activeClass) === 'follow'
            }]),
            onClick: _cache[2] || (_cache[2] = _withModifiers($event => headerRouter('follow'), ["prevent"]))
          }, {
            default: _withCtx(() => [_createTextVNode("关注")]),
            _: 1
          }, 8, ["class"])]),
          _: 1
        }), _createVNode(_component_van_row, {
          class: _normalizeClass(["search-bar", {
            active: state.isShowSearchMenu
          }]),
          justify: "space-between",
          align: "center"
        }, {
          default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
            type: "text",
            id: "search-txt",
            placeholder: "搜帖子标题或用户昵称",
            ref_key: "searchTxt",
            ref: searchTxt,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => searchKeyword.value = $event),
            onKeydown: _cache[4] || (_cache[4] = _withKeys($event => gotoSearch(searchKeyword.value), ["enter"])),
            onBlur: _cache[5] || (_cache[5] = $event => displaySearchMenu(false)),
            onClick: _cache[6] || (_cache[6] = $event => displaySearchMenu(true))
          }, null, 544), [[_vModelText, searchKeyword.value]]), _createElementVNode("i", {
            class: "ico ico-search",
            onClick: _cache[7] || (_cache[7] = $event => gotoSearch(searchKeyword.value))
          }), state.isShowSearchMenu ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "search-menu",
            id: "search-menu",
            onMouseenter: _cache[8] || (_cache[8] = $event => updateMouseInMenu(true)),
            onMouseleave: _cache[9] || (_cache[9] = $event => updateMouseInMenu(false))
          }, [_hoisted_4, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.todayHotThread, (val, idx) => {
            return _openBlock(), _createElementBlock("div", {
              class: "today-thread__item",
              key: 'today-thread-' + idx,
              onClick: $event => gotoThreadDetailPage(val.tid)
            }, [_createElementVNode("div", {
              class: _normalizeClass(["rank", {
                first: idx === 0,
                second: idx === 1,
                third: idx === 2
              }])
            }, _toDisplayString(idx > 2 ? idx + 1 : ''), 3), _createElementVNode("div", {
              class: "today-thread__title",
              innerHTML: val.subject
            }, null, 8, _hoisted_6)], 8, _hoisted_5);
          }), 128)), state.todayHotThread.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_7, " 今日暂无热议 ")) : _createCommentVNode("", true), state.isShowHistory ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createTextVNode("历史搜索"), _createElementVNode("div", {
            class: "btn-clear d-flex align-items-center",
            onClick: clearHistory
          }, [_createTextVNode("清空"), _hoisted_9])])) : _createCommentVNode("", true), state.isShowHistory ? (_openBlock(), _createElementBlock("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.searchHistory, (val, idx) => {
            return _openBlock(), _createElementBlock("div", {
              key: 'h-' + idx,
              onClick: $event => gotoSearch(val)
            }, _toDisplayString(val), 9, _hoisted_11);
          }), 128))])) : _createCommentVNode("", true)], 32)) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["class"]), _unref(isLogin) ? (_openBlock(), _createBlock(_component_van_row, {
          key: 0,
          class: "user-bar",
          justify: "space-between",
          align: "center"
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "btn btn-red-outline btn-sign-in",
            onClick: _cache[10] || (_cache[10] = $event => showSignPopup(true))
          }, [_hoisted_12, _createTextVNode("签到")]), _createElementVNode("div", {
            class: "btn btn-red btn-share",
            onClick: gotoShare
          }, [_hoisted_13, _createTextVNode("发帖")]), _createVNode(_component_van_row, {
            class: "user-info",
            justify: "space-between",
            align: "center"
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: "avatar pointer",
              onClick: gotoThread
            }, [_createElementVNode("img", {
              src: _ctx.$filters.promoteUrl('/' + _unref(userInfo).avatar + '&version=' + _unref(versionControl)),
              alt: ""
            }, null, 8, _hoisted_14), _unref(userInfo).newprompt > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_unref(userInfo).newprompt), 1)) : _createCommentVNode("", true)]), _createVNode(_component_van_col, {
              class: "pointer",
              onClick: gotoThread
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$filters.more(_unref(userInfo).nickname, 8, '')), 1), _createElementVNode("div", _hoisted_17, [_hoisted_18, _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$filters.priceFormatInt(_unref(userInfo).credits)), 1)])]),
              _: 1
            }), _createElementVNode("div", _hoisted_20, [_createVNode(_component_van_row, {
              class: "menu__item thread",
              align: "center"
            }, {
              default: _withCtx(() => [_createVNode(_component_router_link, {
                to: '/user/' + (_unref(userInfo).uid || 0) + '/thread'
              }, {
                default: _withCtx(() => [_hoisted_21, _hoisted_22]),
                _: 1
              }, 8, ["to"])]),
              _: 1
            }), _createVNode(_component_van_row, {
              class: "menu__item draft",
              align: "center"
            }, {
              default: _withCtx(() => [_createVNode(_component_router_link, {
                to: '/user/' + (_unref(userInfo).uid || 0) + '/draft'
              }, {
                default: _withCtx(() => [_hoisted_23, _hoisted_24]),
                _: 1
              }, 8, ["to"])]),
              _: 1
            }), _createVNode(_component_van_row, {
              class: "menu__item reply",
              align: "center"
            }, {
              default: _withCtx(() => [_createVNode(_component_router_link, {
                to: '/user/' + (_unref(userInfo).uid || 0) + '/thread/reply'
              }, {
                default: _withCtx(() => [_hoisted_25, _hoisted_26]),
                _: 1
              }, 8, ["to"])]),
              _: 1
            }), _createVNode(_component_van_row, {
              class: "menu__item message",
              align: "center"
            }, {
              default: _withCtx(() => [_createVNode(_component_router_link, {
                to: '/user/' + (_unref(userInfo).uid || 0) + '/notice'
              }, {
                default: _withCtx(() => [_createElementVNode("img", {
                  src: _imports_3,
                  width: 19,
                  height: 16.5,
                  alt: ""
                }, null, 8, _hoisted_27), _hoisted_28, _unref(userInfo).newprompt > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_unref(userInfo).newprompt), 1)) : _createCommentVNode("", true)]),
                _: 1
              }, 8, ["to"])]),
              _: 1
            }), _createVNode(_component_van_row, {
              class: "menu__item bill",
              align: "center"
            }, {
              default: _withCtx(() => [_createVNode(_component_router_link, {
                to: '/user/' + (_unref(userInfo).uid || 0) + '/bill'
              }, {
                default: _withCtx(() => [_hoisted_30, _hoisted_31]),
                _: 1
              }, 8, ["to"])]),
              _: 1
            }), _createVNode(_component_van_row, {
              class: "menu__item logout",
              align: "center"
            }, {
              default: _withCtx(() => [_createElementVNode("a", {
                href: "#",
                onClick: _cache[11] || (_cache[11] = _withModifiers($event => _unref(logout)(), ["prevent"]))
              }, [_createElementVNode("img", {
                src: _imports_5,
                width: 15,
                height: 12.5,
                alt: ""
              }, null, 8, _hoisted_32), _hoisted_33])]),
              _: 1
            })])]),
            _: 1
          })]),
          _: 1
        })) : (_openBlock(), _createBlock(_component_van_row, {
          key: 1,
          class: "user-bar guest",
          justify: "space-between",
          align: "center"
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "btn btn-red-outline btn-login",
            onClick: _cache[12] || (_cache[12] = $event => showLoginBox('login'))
          }, "登录"), _createElementVNode("div", {
            class: "btn btn-red-img btn-register",
            onClick: _cache[13] || (_cache[13] = $event => showLoginBox('reg'))
          }, "注册")]),
          _: 1
        }))]),
        _: 1
      }), _createVNode(duFloatMenu, {
        ref_key: "duFloatMenuRef",
        ref: duFloatMenuRef
      }, null, 512)], 34);
    };
  }
};